import LockerCardCarrierBadge from "@components/Lockers/LockerCard/LockerCardCarrierBadge";

import LockerCardRoutingAction from "@components/Lockers/LockerCard/LockerCardRoutingAction";
import LockerCardSaveOrDeleteAction from "@components/Lockers/LockerCard/LockerCardSaveOrDeleteAction";
import LockerCardSchedule from "@components/Lockers/LockerCard/LockerCardSchedule";
import LockerCardName from "@components/Lockers/LockerCard/LockerCardName";
import LockerCardAddress from "@components/Lockers/LockerCard/LockerCardAddress";
import LockerCardInactiveTag from "@components/Lockers/LockerCard/LockerCardInactiveTag";
import { LOCKER_INACTIVE_MESSAGE } from "@components/Lockers/_lib/constants";
import isLockerInactive from "@components/Lockers/_lib/isLockerInactive";
import Alert from "@components/Alert";
import Button from "@components/Button";

const SelectedLockerView = ({
  locker,
  onSaveOrDeleteFavouriteLocker,
  onLockerDeselect,
  onLockerSelect,
}) => {
  const isInactive = isLockerInactive(locker);

  return (
    <div className="space-y-[10px]">
      <div
        className="text-red-brand cursor-pointer flex gap-[4px] pb-[20px]"
        onClick={onLockerDeselect}
      >
        &lt;&lt; <span className="underline">Inapoi la lista</span>
      </div>

      <div className="flex flex-wrap items-center gap-[8px]">
        <LockerCardCarrierBadge locker={locker} />

        <LockerCardInactiveTag locker={locker} />
      </div>

      <div>
        <LockerCardName locker={locker} />
        <LockerCardAddress locker={locker} />

        <LockerCardSchedule />
      </div>

      {isInactive && (
        <Alert type="warning" showIcon hasMinWidth={false}>
          {LOCKER_INACTIVE_MESSAGE}
        </Alert>
      )}

      {onLockerSelect && (
        <Button
          title="Selecteaza"
          classesProp="max-w-fit"
          onClick={onLockerSelect}
          disabled={isInactive}
        />
      )}

      <div className="py-[10px] border-y border-[#E6E6E6]">
        <LockerCardSaveOrDeleteAction
          locker={locker}
          onSaveOrDeleteFavouriteLocker={onSaveOrDeleteFavouriteLocker}
          isDisabled={isInactive}
        />
      </div>

      <LockerCardRoutingAction locker={locker} />
    </div>
  );
};

export default SelectedLockerView;
